export default "__VITE_ASSET__UK$nBJMd__"